import { graphql } from "../../gql";

export const IS_NICKNAME_TAKEN = graphql(/* GraphQL */ `
  query IsNicknameTaken($nickname: String!, $gameId: String!) {
    gameIsNicknameTaken(nickname: $nickname, gameId: $gameId)
  }
`);

export const GET_LEADERBOARD = graphql(/* GraphQL */ `
  query GetLeaderboard($gameId: String!) {
    gameLeaderboard(gameId: $gameId) {
      id
      nickname
      rank
      timeInMs
      points
    }
  }
`);

export const GET_CURRENT_ROW = graphql(/* GraphQL */ `
  query GetCurrentRow($responseId: String, $responseSlug: Int) {
    currentRow: gameLeaderboardResponseRank(responseId: $responseId, responseSlug: $responseSlug) {
      id
      nickname
      rank
      timeInMs
      points
    }
  }
`);
